import { useVendors } from '@/composables/app/useVendors'
import { get as _get } from 'lodash'

const { video_vendors, getVendorRegexExpression } = useVendors()

const expressions = {
  link: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
  iframe: /^<iframe(.)+<\/iframe>$/g,
  ...video_vendors.reduce((acc, { name }) => ({ ...acc, [name]: getVendorRegexExpression({ name, flags: 'g' }) }), {})
}

export default name => {
  return _get(expressions, name)
}